module.exports = __webpack_public_path__ + "static/media/pen.1f83eaf1.svg";